export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";